import React from "react";
import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";
import { IS_VATAR } from "../vatar/env";
import { getFinalStandings, getGameEndedDate } from "./Utils/roomHelpers";
import RematchPanel from "./RematchPanel";
import { REPLAY_COPY } from "../utils/hostingCopy";

// The results screen a player sees after a reload, a reconnect, My Rooms or a
// join link. Shares the play-again panel with the live results screen.
const FinalGameResults = ({ roomData, roomDocId, currentUserId }) => {
  const navigate = useNavigate();
  const standings = getFinalStandings(roomData);
  const gameEndedAt = getGameEndedDate(roomData.gameEndedAt);

  return (
    <div className="max-w-4xl mx-auto text-center">
      <div className="md:text-4xl text-2xl font-bold text-red-800 mb-4">GAME COMPLETE!</div>
      {roomData.roomName && <p className="text-gray-600 mb-2">Room: {roomData.roomName}</p>}
      <p className="text-gray-600 mb-8">Game ended on {gameEndedAt}</p>

      <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
        <div className="flex justify-center items-end space-x-8 mb-8">
          {standings.slice(0, 3).map((player, index) => (
            <div key={player.name} className="text-center">
              <div
                className={`w-20 h-20 mx-auto mb-2 rounded-full flex items-center justify-center text-3xl ${
                  index === 0 ? "bg-yellow-400" : index === 1 ? "bg-gray-400" : "bg-orange-400"
                }`}
              >
                {index === 0 ? "🥇" : index === 1 ? "🥈" : "🥉"}
              </div>
              <div className="font-bold text-lg">{player.name}</div>
              <div className="text-2xl font-bold text-red-600">{player.total} pts</div>
            </div>
          ))}
        </div>

        <div className="max-w-md mx-auto">
          <h3 className="text-lg font-semibold mb-4">Complete Results</h3>
          {standings.map((player, index) => (
            <div key={player.name} className="flex justify-between items-center py-2 border-b border-gray-100">
              <div className="flex items-center space-x-3">
                <span className="text-lg font-bold">{index + 1}.</span>
                <span>{player.name}</span>
              </div>
              <span className="font-bold text-red-600">{player.total} pts</span>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
        <h3 className="text-xl font-semibold mb-4">Game Summary</h3>
        <div className="grid grid-cols-2 gap-4 text-center">
          <div>
            <div className="text-2xl font-bold text-red-600">{roomData.currentRound || 0}</div>
            <div className="text-gray-600">Rounds Played</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-red-600">{roomData.playedLetters?.length || 0}</div>
            <div className="text-gray-600">Letters Used</div>
          </div>
        </div>
      </div>

      {!IS_VATAR && (
        <RematchPanel roomData={roomData} roomDocId={roomDocId} currentUserId={currentUserId} />
      )}
      <button
        onClick={() => navigate("/")}
        className="bg-gray-800 text-white font-semibold px-8 py-3 rounded-xl hover:bg-gray-900 transition duration-300 inline-flex items-center gap-2"
      >
        <Home size={20} />
        {REPLAY_COPY.backHome}
      </button>
    </div>
  );
};

export default FinalGameResults;
